export enum PublishedStorymapAccessKind {
    Public = 0,
    PrivateLink = 1,
}

export interface PublishedStorymapRouteContext {
    isPublishedRecipient: boolean;
    accessKind: PublishedStorymapAccessKind | null;
    accessKey: string;
}

export const emptyPublishedStorymapRouteContext = (): PublishedStorymapRouteContext => ({
    isPublishedRecipient: false,
    accessKind: null,
    accessKey: '',
});

export const privateLinkStorymapRouteContext = (token: string): PublishedStorymapRouteContext => ({
    isPublishedRecipient: true,
    accessKind: PublishedStorymapAccessKind.PrivateLink,
    accessKey: token,
});

export const publicStorymapRouteContext = (slug: string): PublishedStorymapRouteContext => ({
    isPublishedRecipient: true,
    accessKind: PublishedStorymapAccessKind.Public,
    accessKey: slug,
});

export const buildStorymapRoute = (slug: string, routeContext?: PublishedStorymapRouteContext): string => {
    if (routeContext?.isPublishedRecipient && routeContext.accessKind === PublishedStorymapAccessKind.PrivateLink) {
        return `/storymap/shared/${routeContext.accessKey}`;
    }

    return `/storymap/${slug}`;
};

export const buildStorymapCardRoute = (slug: string, cardId: string, routeContext?: PublishedStorymapRouteContext): string => {
    if (routeContext?.isPublishedRecipient && routeContext.accessKind === PublishedStorymapAccessKind.PrivateLink) {
        return `/storymap/shared/${routeContext.accessKey}/${cardId}`;
    }

    return `/storymap/${slug}/${cardId}`;
};

export const buildStorymapReleaseRoute = (slug: string, releaseId: string, routeContext?: PublishedStorymapRouteContext): string => {
    if (routeContext?.isPublishedRecipient && routeContext.accessKind === PublishedStorymapAccessKind.PrivateLink) {
        return `/storymap/shared/${routeContext.accessKey}/release/${releaseId}`;
    }

    return `/storymap/${slug}/release/${releaseId}`;
};

export const isPrivateSharedStorymapPath = (path: string): boolean => /^\/storymap\/shared(\/|$)/i.test(path);
